__turbopack_context__.v({
  "footer": "pl0i9q_footer",
  "footerLink": "pl0i9q_footerLink",
  "headerLink": "pl0i9q_headerLink",
});
